/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { task } from 'ember-concurrency';

@tagName('')
export default class CopyWarningList extends Component {
  @service apiErrors;

  // external
  warnings = null;
  hasReadOnlyPermission = true;

  dismissWarningTask = null;

  // internal
  _dismissWarningTask = task(async (warning) => {
    try {
      await this.dismissWarningTask.perform(warning);
    } catch (errors) {
      this.apiErrors.report(errors);
    }
  });
}
